import { useCallback, useState } from 'react'

export const useModalForm = (initialIsVisibleValue?: boolean) => {
    const [isVisible, setIsVisible] = useState(initialIsVisibleValue) // makes it false by default

    const hideForm = useCallback(() => {
        setIsVisible(false)
    }, [])

    const showForm = useCallback(() => {
        setIsVisible(true)
    }, [])

    const toggleFormVisibility = useCallback(() => {
        setIsVisible((isVisible) => !isVisible)
    }, [])

    return {
        hideForm,
        isVisible,
        showForm,
        toggleFormVisibility
    }
}
